import { Flex, Text, Tooltip } from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';
import { ACTIVITIES_COLORS, CHART_COLORS } from 'theme/styles';
import { ACTIVITIES } from 'types';

const getColor = (type: ACTIVITIES) => {
    const colors = {
        [ACTIVITIES.calls]: ACTIVITIES_COLORS.calls,
        [ACTIVITIES.dds]: ACTIVITIES_COLORS.dds,
        [ACTIVITIES.uniqueCalls]: ACTIVITIES_COLORS.uniqueCalls,
        [ACTIVITIES.earlyHangUps]: ACTIVITIES_COLORS.earlyHangUps,
        [ACTIVITIES.sms]: ACTIVITIES_COLORS.sms,
        [ACTIVITIES.pickUps]: ACTIVITIES_COLORS.pickUps,
        [ACTIVITIES.convos]: ACTIVITIES_COLORS.convos,
        [ACTIVITIES.offers]: ACTIVITIES_COLORS.offers,
        [ACTIVITIES.dq]: ACTIVITIES_COLORS.dq,
        [ACTIVITIES.sets]: ACTIVITIES_COLORS.sets,
        [ACTIVITIES.triage]: ACTIVITIES_COLORS.triage,
    };

    return colors[type];
};

type TProps = {
    type?: ACTIVITIES;
    color?: string;
    value?: number | string;
    width?: string;
    label?: ReactNode | ReactElement;
};

const ActivityIndicator = ({ type, color, value, width, label }: TProps) => {
    const bg = color || getColor(type);
    const size = value ? '20px' : '12px';
    const radius = value ? '4px' : '2px';

    const isSMS = type === ACTIVITIES.sms;

    const isWhite = type === ACTIVITIES.calls;
    const textColor = isWhite ? 'white' : 'black';

    return !!label ? (
        <Tooltip hasArrow label={label}>
            <Flex
                h={size}
                w={width || size}
                bg={bg}
                borderRadius={isSMS ? '50%' : radius}
                alignItems="center"
                justifyContent="center"
            >
                {!!value && (
                    <Text fontSize="10px" fontWeight="700" color={textColor}>
                        {value}
                    </Text>
                )}
            </Flex>
        </Tooltip>
    ) : (
        <Flex
            h={size}
            w={width || size}
            bg={bg}
            borderRadius={isSMS ? '50%' : radius}
            alignItems="center"
            justifyContent="center"
        >
            {!!value && (
                <Text fontSize="10px" fontWeight="700" color={textColor}>
                    {value}
                </Text>
            )}
        </Flex>
    );
};

export default ActivityIndicator;
